export default __webpack_public_path__ + "static/ConcordeBQReg-48a51fed01b65ec17fc0f44bd66f5e09.otf";